const BASE_PATH = '/inventory/candidates';

export const NEW_CANDIDATE_ENDPOINTS = {
  drafts: `${BASE_PATH}/drafts`,
  draft: `${BASE_PATH}/drafts/:id`
};
